var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{attrs:{"colspan":_vm.colspan}},[_vm._v("\n    Total: "+_vm._s(_vm.money(_vm.total))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }